import React from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const VisagersPopup = ({ open, onClose, fileId, caseVisagers, users }) => {
    const rolesInGeorgian = {
        'HEADOFAGENCY': "სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "სამმართველოს უფროსი",
        'EXPERT': "სპეციალისტი"
    };

    const DepartmentEnum = {
        1: "მომეტებული ტექნიკური საფრთხის შემცველი ობიექტების ზედამხედველობის სამმართველო",
        2: "განსაკუთრებული ობიექტების მშენებლობის ნებართვებისა და ზედამხედველობის სამმართველო",
        3: "სამართლებრივი უზრუნველყოფის სამმართველო",
        4: "ადმინისტრირებისა და ინფორმაციული უზრუნველყოფის სამმართველო"
    };

    const isFileApproved = (approverDetails) => {
        return approverDetails && approverDetails.split(',').includes(fileId.toString()) ? "კი" : "არა";
    };

    const departmentVisagers = caseVisagers.reduce((acc, visager) => {
        const user = users.find(user => user.id === visager.toUserId);
        const depId = user ? user.departmentId : null;
        if (depId) {
            acc[depId] = acc[depId] || [];
            acc[depId].push({
                ...visager,
                roleName: rolesInGeorgian[user.roleName.toUpperCase()],
                rolePriority: user.roleName.toUpperCase() === 'HEADOFDEPARTMENT' ? 0 : 1
            });
        }
        return acc;
    }, {});

    const renderDepartmentTable = (departmentId, visagers) => (
        <Box key={departmentId} marginBottom={4}>
            <div style={{marginBottom: 30}} className="old-objects-title">
                {DepartmentEnum[departmentId]}
            </div>
            <TableContainer component={Paper} style={{ width: '100%' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>ვიზატორი</TableCell>
                            <TableCell>როლი</TableCell>
                            <TableCell>დეპარტემნტი</TableCell>
                            <TableCell bgColor={"#f0f0f0"} align={"center"}>დაავიზა</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {visagers.sort((a, b) => a.rolePriority - b.rolePriority).map((visager) => (
                            <TableRow key={visager.id}>
                                <TableCell style={{width: 200}}>{visager.toUserName}</TableCell>
                                <TableCell style={{width: 200}}>{visager.roleName}</TableCell>
                                <TableCell style={{width: 400}}>{DepartmentEnum[departmentId]}</TableCell>
                                <TableCell style={{width: 50}}  bgColor={"#f0f0f0"} align={"center"}> {isFileApproved(visager.approverDetalis)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="flex-end">
                    <IconButton onClick={onClose} edge="end" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                {Object.keys(departmentVisagers).map(depId => renderDepartmentTable(depId, departmentVisagers[depId]))}
            </DialogContent>
        </Dialog>
    );
};

export default VisagersPopup;
